import { Dropdown } from "primereact/dropdown";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { defaultCronObject, Props } from "../CrontabView";
import classes from "./MinutesForm.module.scss";

const MINUTES: number[] = Array.from(Array(59).keys()).map((min) => min + 1);

export const MinutesForm = ({ onCronChanged, date }: Props) => {
  
  const { t: translate } = useTranslation();

  useEffect(() => {
    onCronChanged({
      ...defaultCronObject,
      minutes: `*/${date?.getMinutes().toString()}`
    });
  }, []);


  const intervalByMinutes = (minutes: string): string => {
    return `*/${minutes}`;
  };

  const changeHandler = (val: string) => {
    onCronChanged({
      ...defaultCronObject,
      minutes: intervalByMinutes(val),
    });
  };

  return (
    <div className={classes["form-control"]}>
      <label> {translate("cron-tab.input.of")} </label>
      <Dropdown
        value={ date.getMinutes() }
        options={MINUTES}
        onChange={(e) => changeHandler(e.value)}
        placeholder={translate("cron-tab.recurrence")}
      />
      <span className="p-text-secondary">Minutes</span>
    </div>
  );
};
